export const noneGroupHeader = "Xyc";
export default {noneGroupHeader};